<template>
    <el-collapse-item title="图例">
        <el-form-item>
            <div class="chart-form-item-warp">
                <span class="jz-chart-title-label">
                    是否开启
                </span>
                <el-switch v-model="config.show"></el-switch>
            </div>
        </el-form-item>
        <el-form-item>
            <div class="chart-form-item-warp">
                <span class="jz-chart-title-label">
                    位置
                </span>
                <el-select v-model="config.position" placeholder="请选择" popper-class="c-select-style-popper">
                    <el-option v-for="option in positionOptions" :key="option.value" :label="option.label"
                        :value="option.value"></el-option>
                </el-select>
            </div>
        </el-form-item>
    </el-collapse-item>
</template>

<script>
export default {
    name: 'cBiDashboardLegendStyle',
    props: {
        config: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            positionOptions: [
                { label: '顶部', value: 'top' },
                { label: '顶部左侧', value: 'top-left' },
                { label: '顶部右侧', value: 'top-right' },
                { label: '左侧', value: 'left' },
                { label: '左侧顶部', value: 'left-top' },
                { label: '左侧底部', value: 'left-bottom' },
                { label: '右侧', value: 'right' },
                { label: '右侧顶部', value: 'right-top' },
                { label: '右侧底部', value: 'right-bottom' },
                { label: '底部', value: 'bottom' },
                { label: '底部左侧', value: 'bottom-left' },
                { label: '底部右侧', value: 'bottom-right' }
            ]
        }
    }
}
</script>

<style scoped lang="less">
// 图例样式组件
</style>